<template>
  <div>
    <div v-if="!isOnline" class="network-status">
      You are offline. Some features may not work.
    </div>
    <div v-if="false" class="support">
      <font-awesome-icon icon="headset" class="support-icon" />
      <span> Please note that our current support line is currently down. Please reach us on 0765631486.</span>
      <button @click="closeSupportNotice" class="close-button">
        <font-awesome-icon icon="times" />
      </button>
    </div>
    <div v-if="updateAvailable" class="update-banner">
      <div class="update-content">
        <font-awesome-icon icon="download" class="update-icon" />
        <div class="update-text">
          <span class="update-title">Hardware Service Update Available</span>
          <span class="update-description">A new version of the Hardware Service is ready to install</span>
        </div>
        <button 
          @click="applyUpdate" 
          class="update-button"
          :class="{ 'updating': isUpdating }"
          :disabled="isUpdating"
        >
          <span v-if="!isUpdating">Update Now</span>
          <span v-else>
            <font-awesome-icon icon="spinner" spin /> Updating...
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faSpinner, faHeadset, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapState, mapMutations } from 'vuex';

library.add(faDownload, faSpinner, faHeadset, faTimes);

export default {
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState(['showSupportNotice']),
  },
  data() {
    return {
      isOnline: navigator.onLine,
      networkCheckInterval: null,
      updateAvailable: false,
      isUpdating: false,
      intervalId: null,
    };
  },
  methods: {
    ...mapMutations(['setShowSupportNotice']),
    closeSupportNotice() {
      this.setShowSupportNotice(false);
      localStorage.setItem('lastSupportNoticeTime', Date.now());
    },
    startSupportNoticeInterval() {
      const lastTriggerTime = localStorage.getItem('lastSupportNoticeTime');
      const oneHour = 3600000; // 1 hour in ms
      const timeSinceLastTrigger = Date.now() - (lastTriggerTime || 0);

      if (timeSinceLastTrigger < oneHour) {
        const remainingTime = oneHour - timeSinceLastTrigger;
        setTimeout(() => {
          this.setShowSupportNotice(true);
          this.intervalId = setInterval(() => {
            this.setShowSupportNotice(true);
          }, oneHour);
        }, remainingTime);
      } else {

        this.setShowSupportNotice(true);
        this.intervalId = setInterval(() => {
          this.setShowSupportNotice(true);
        }, oneHour);
      }
    },
    updateNetworkStatus() {
      this.isOnline = navigator.onLine;
    },
    detectOS() {
      let platform = navigator.platform.toLowerCase();
      let userAgent = navigator.userAgent.toLowerCase();
      if (platform.includes('win')) {
        return 'Windows';
      } else if (/android/.test(userAgent)) {
        return 'Android';
      } else if (platform.includes('mac') || userAgent.includes('mac os')) {
        return 'MacOS';
      } else if (platform.includes('linux')) {
        return 'Linux';
      } else if (/iphone|ipad|ipod/.test(userAgent)) {
        return 'iOS';
      } else {
        return 'Unknown OS';
      }
    },
    async checkForUpdates() {
      try {
        const response = await axios(hardwareApi + 'update/available');
        const data = response.data;

        const os = this.detectOS();

        if (os === 'Windows') {
          this.updateAvailable = data;
          if (this.updateAvailable) {
          } else {
          }
        } else if (os === 'Linux') {
        }
      }
      catch (error) {
        this.updateAvailable = false;
      }
    },
    async checkNetworkConnectivity() {
      try {
        const response = await fetch('https://dns.google', {
          mode: 'no-cors',
          cache: 'no-store'
        });
        this.isOnline = true;
      } catch (error) {
        this.isOnline = false;
      }
    },
    startNetworkCheck() {
      if (this.networkCheckInterval) {
        clearInterval(this.networkCheckInterval);
      }
      this.networkCheckInterval = setInterval(() => {
        this.checkNetworkConnectivity();
      }, 10000);
    },
    stopNetworkCheck() {
      if (this.networkCheckInterval) {
        clearInterval(this.networkCheckInterval);
        this.networkCheckInterval = null;
      }
    },
    async applyUpdate() {
      this.isUpdating = true;
      try {
        const response = await axios(hardwareApi + 'update');
        const result = await response.data;
        this.$utils.showLoading();
        window.updatingHardware = true;
        
        setTimeout(() => {
          this.$utils.hideLoading();
          window.updatingHardware = false;
        }, 15000);

        this.updateAvailable = false;

      } catch (error) {
        console.error('Update error:', error);
        alert('Update failed. Please try again later.');
        window.updatingHardware = false;
      } finally {
        this.isUpdating = false;
      }
    }
  },
  created() {
    this.$store.dispatch('initializeStore');
    window.addEventListener('online', this.updateNetworkStatus);
    window.addEventListener('offline', this.updateNetworkStatus);
    this.startNetworkCheck();
    this.checkForUpdates();
    setInterval(this.checkForUpdates, 3600000);
    this.startSupportNoticeInterval();
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateNetworkStatus);
    window.removeEventListener('offline', this.updateNetworkStatus);
    this.stopNetworkCheck();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style scoped>
.network-status {
  background-color: #ffc107;
  color: #212529;
  padding: 10px;
  text-align: center;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  animation: blink 1s infinite;
}

.support {
  background-color: rgba(185, 174, 12, 0.712);
  color: #000000;
  padding: 12px 24px;
  text-align: center;
  position: fixed;
  top: 10px;
  right: 600px;
  z-index: 999;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-weight: 500;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 400px;
  font-size: 0.95rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 8px;
  animation: blink 1s infinite;
}

.support-icon {
  font-size: 18px;
  color: #1a73e8;
}

.close-button {
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  font-size: 14px;
  margin-left: auto;
}

.close-button:hover {
  opacity: 0.7;
}

.update-banner {
  background-color: #1a73e8;
  color: white;
  padding: 12px 24px;
  width: 100%;
  position: fixed;
  top: 80px; /* Position below both network status and support banner if they're visible */
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.update-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
}

.update-icon {
  font-size: 24px;
  color: #ffffff;
}

.update-text {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.update-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
}

.update-description {
  font-size: 14px;
  opacity: 0.9;
}

.update-button {
  background-color: #ffffff;
  color: #1a73e8;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.update-button:hover:not(:disabled) {
  background-color: #f8f9fa;
  transform: translateY(-1px);
}

.update-button:active:not(:disabled) {
  transform: translateY(0);
}

.update-button.updating {
  background-color: #e8f0fe;
  cursor: not-allowed;
}

.update-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>